import React, { useCallback, useEffect, useState } from 'react'
import Leds from '../leds/Leds';
import ValLabel from './ValLabel';
import ValEdit from './ValEdit';
import Glide from '../glide/Glide';
import { useItemListenerContext } from '../../../../providers/ItemListenerContextProvider';
import './ValCell.css';

export default function ValCell({folderPath, keyName, value, kInfo, tabIx='1'}) {
  const LABEL_MODE = 'labelMode';
  const VAL_INPUT_MODE = 'valInputMode'
  const [mode, setMode] = useState(kInfo?.valEdit ? VAL_INPUT_MODE : LABEL_MODE);
  const [locked, setLocked] = useState(kInfo.valLocked);
  const [success, setSuccess] = useState(kInfo.valSuccess);
  const {tagValueLocked, resetValueLocked} = useItemListenerContext();

  //
  const setEditMode = useCallback(() => {
    if (!locked) {
      setMode(VAL_INPUT_MODE);
    }
    else {
      console.log('Value LOCKED');
    }
  }, [locked]);

  //
  const setLabelMode = useCallback(() => {
    setMode(LABEL_MODE);
  },[]);

  //
  useEffect(()=>{    
    if (kInfo) {
      setMode(kInfo.valEdit ? VAL_INPUT_MODE : LABEL_MODE);
      setLocked(kInfo.valLocked);
      setSuccess(kInfo.valSuccess);
      // Similarly.. setModified, etc
    }
  }, [kInfo]);

  //
  const lockMe = useCallback((e) => {
    e.preventDefault();
    tagValueLocked(folderPath, keyName)
      .then(()=>setLocked(true));
  }, [tagValueLocked, folderPath, keyName]);

  //
  const unlockMe = useCallback((e) => {
    resetValueLocked(folderPath, keyName)
      .then(()=>setLocked(false));
  }, [resetValueLocked, folderPath, keyName]);

  // ---[  Render  ]---

  return (
    <div className='valCell-value withGliders' onContextMenuCapture={lockMe}>
      <Leds isError={kInfo.valErrorInfo?.errorTag.startsWith('prop-value')} />
      <Glide showLock={locked} showDelete={false} unlocker={unlockMe}/>
      {mode === LABEL_MODE      && <ValLabel  val={value} setEditMode={setEditMode} isLocked={locked} isSuccess={success} key={`valLabelOf-${keyName}`}/>}
      {mode === VAL_INPUT_MODE  && <ValEdit   folderPath={folderPath} keyName={keyName} val={value} tabIx={tabIx} setLabelMode={setLabelMode} kInfo={kInfo} key={`valEditOf-${keyName}`} />}
    </div>
  )
}
